import { render, staticRenderFns } from "./DraggableTreeviewNode.vue?vue&type=template&id=ec8b7e30"
import script from "./DraggableTreeviewNode.vue?vue&type=script&lang=js"
export * from "./DraggableTreeviewNode.vue?vue&type=script&lang=js"
import style0 from "./DraggableTreeviewNode.vue?vue&type=style&index=0&id=ec8b7e30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports